import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import useSearch from "hooks/useSearch"
import { getMonitorProviderIns } from "store/monitor-receipts/monitor-receipt-action"
import {
  getMonitorIps,
  getMonitorItemCategories,
  getMonitorProjects,
  getMonitorProviders,
} from "store/monitor-dashboard/monitor-dashboard-action"
import MonitorReceiptsComponent from "components/MonitorReceipts/list"
import ProviderInDetailModal from "components/ProviderIn/details"
import { exportMonitorReceiptReport } from "store/monitor-reports/monitor-report-action"

const MonitorReceipts = () => {
  // Meta Title
  document.title = "Receipts"

  // Current status of the export process for the consumption report, retrieved from the Redux store
  const exportStatus = useSelector(
    state => state.monitorReports.monitorExportReceiptReport
  )

  const dispatch = useDispatch()
  const { data, error, loading } = useSelector(state => state.monitorReceipts)
  const [proIn, setProIn] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const [detailModal, setDetailModal] = useState(false)

  // Fetches new activity logs when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getMonitorProviderIns(
        link.url,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }

  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // Custom Search Hook called everytime search updates
  useSearch(
    getMonitorProviderIns(
      undefined,
      undefined,
      undefined,
      search,
      advnacedSearch
    ),
    search
  )

  // fetch new Provider Distribution Action Requests based page number or according changes
  useEffect(() => {
    dispatch(
      getMonitorProviderIns(
        undefined,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }, [pageNumber, according])

  // fetch receipts and other data need for filter select box
  useEffect(() => {
    dispatch(getMonitorItemCategories())
    dispatch(getMonitorIps())
    dispatch(getMonitorProjects())
    dispatch(getMonitorProviders())
  }, [])

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(
      getMonitorProviderIns(undefined, undefined, undefined, search, data)
    )
  }

  // Show distribution details in a modal when the detail button is clicked
  const onClickDetail = data => {
    setProIn(data)
    setDetailModal(true)
  }
  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(
      exportMonitorReceiptReport(pageNumber, according, search, advnacedSearch)
    )
  }

  return (
    <React.Fragment>
      <Breadcrumbs title={"Monitor"} breadcrumbItem={"Receipts"} />
      {/* Provider Detail Modal  */}
      <ProviderInDetailModal
        data={proIn}
        open={detailModal}
        setOpen={setDetailModal}
      />
      {/* Monitor Receipt Component  */}
      <MonitorReceiptsComponent
        data={data}
        error={error}
        loading={loading}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        onClickDetail={onClickDetail}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
      />
    </React.Fragment>
  )
}

export default MonitorReceipts
